module.exports = __webpack_public_path__ + "static/media/purchaseNew.3bb83ce1.svg";